<ds-segmented-control [fullWidth]="true" [activeOption]="getActiveOption() + ''" (activeOptionChange)="onSelectionChange($event)">
    @for (tab of tabs; track tab; let i = $index) {
        <ds-segmented-option [name]="i + ''" [title]="getTabTitle(tab)" />
    }
</ds-segmented-control>
F
